// extracted by mini-css-extract-plugin
module.exports = {"button":"y0P1pQKhCIapXYE9eRMneQ=="};